var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.5237 27.4284V12.1903H18.857C17.2796 12.1903 15.9999 10.9105 15.9999 9.33315V2.66648H8.38081C7.32724 2.66648 6.47605 3.51767 6.47605 4.57124V27.4284C6.47605 28.482 7.32724 29.3331 8.38081 29.3331H23.6189C24.6725 29.3331 25.5237 28.482 25.5237 27.4284ZM25.4939 10.2855C25.4522 10.1189 25.3689 9.9641 25.2439 9.84505L18.3451 2.94624C18.2201 2.82124 18.0713 2.73791 17.9046 2.69624V9.33315C17.9046 9.85696 18.3332 10.2855 18.857 10.2855H25.4939ZM4.57129 4.57124C4.57129 2.47005 6.27962 0.761719 8.38081 0.761719H17.6725C18.4284 0.761719 19.1546 1.06529 19.6903 1.601L26.5891 8.49386C27.1249 9.02958 27.4284 9.75577 27.4284 10.5117V27.4284C27.4284 29.5296 25.7201 31.2379 23.6189 31.2379H8.38081C6.27962 31.2379 4.57129 29.5296 4.57129 27.4284V4.57124Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.97f0fbd6919cbcbd17ca1b333879e03e.svg";
export { ForwardRef as ReactComponent };